/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2022
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Select, SelectItem } from 'carbon-components-react';
import { uniqueId, isEqual } from 'lodash';

export class TestToolSecurityFlows extends Component {
  constructor(props) {
    super(props);
    this.handleFlowChange = this.handleFlowChange.bind(this);
    this.state = { flow: null };
  }

  UNSAFE_componentWillMount() {
    const id = uniqueId('security-flow-select');
    this.setState({ id: id });
  }

  componentDidMount() {
    this.configure(this.props);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps, this.props)) {
      this.configure(this.props);
    }
  }

  configure(props) {
    let newState = {};
    if (!this.state.flow) {
      newState.flow = Object.keys(props.flows)[0];
    }
    if (props.currentFlow && this.state.flow !== props.currentFlow) {
      newState.flow = props.currentFlow;
    }
    this.setState(newState);
  }

  handleFlowChange(event) {
    if (this.props.onChange && typeof this.props.onChange === 'function') {
      this.props.onChange(event.target.value);
    }
  }

  render() {
    let { flows } = this.props;

    let { flow } = this.state;

    const id = this.state.id;

    return (
      <div className="securityFlowChooser">
        {flow && (
          <Select value={flow} onChange={this.handleFlowChange} id={id} hideLabel>
            {Object.keys(flows).map((currentflow) => {
              return <SelectItem key={currentflow} value={currentflow} text={currentflow} />;
            })}
          </Select>
        )}
      </div>
    );
  }
}

export default withTranslation()(TestToolSecurityFlows);
